import { render, staticRenderFns } from "./ComplainTypeFormModal.vue?vue&type=template&id=26d3580f&"
import script from "./ComplainTypeFormModal.vue?vue&type=script&lang=js&"
export * from "./ComplainTypeFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports